export function getFieldParentObject(
	branch: unknown[]
): Record<string, unknown> {
	if (branch.length < 2) {
		throw new Error('Unable to check fields on non-object structs');
	}

	const parent = branch.at(-2);

	if (typeof parent !== 'object' || parent === null) {
		throw new Error('Unable to check fields on non-object structs');
	}

	return parent as Record<string, unknown>;
}
